const statuses = ["Draft", "Planning", "Approved", "Active", "Debrief", "Closed"];

export default function OperationsBoard({ title = "Operations Board", operations, filterTypes, onCreate, onEdit, onDelete, onStatus, onCreateAar }) {
  const filtered = filterTypes?.length ? operations.filter((op) => filterTypes.includes(op.operationType || op.missionType)) : operations;

  return (
    <section>
      <div className="section-head">
        <div>
          <h2>{title}</h2>
          <p className="muted">Create, edit, track, and close tactical operations.</p>
        </div>
        <button className="primary" onClick={onCreate}>Create Operation</button>
      </div>

      <div className="mission-list">
        {filtered.map((op) => (
          <div className={`mission-card priority-${String(op.priority || "normal").toLowerCase()}`} key={op.id}>
            <div className="mission-main">
              <div className="mission-title">{op.title}</div>
              <div className="mission-meta">
                {op.operationType || op.missionType || "Operation"} • {op.location || "No location"} • {formatDate(op.operationDate)}
              </div>
              <p>{op.objective || "No objective entered."}</p>
              <div className="chips">
                <span className={`badge ${op.priority === "Critical" ? "danger" : op.priority === "High" ? "warn" : "neutral"}`}>{op.priority}</span>
                <span className="badge neutral">{op.status}</span>
                {op.commander ? <span className="badge neutral">Cmd: {op.commander}</span> : null}
              </div>
            </div>

            <div className="mission-actions">
              <select value={op.status} onChange={(e) => onStatus(op.id, e.target.value)}>
                {statuses.map((s) => <option key={s}>{s}</option>)}
              </select>
              <button onClick={() => onEdit(op)}>Edit</button>
              <button onClick={() => onCreateAar(op)}>Start AAR</button>
              <button className="danger-text" onClick={() => onDelete(op.id)}>Delete</button>
            </div>
          </div>
        ))}
      </div>

      {filtered.length === 0 ? <div className="empty">No operations found.</div> : null}
    </section>
  );
}

function formatDate(value) {
  if (!value) return "No date";
  try {
    return new Date(value).toLocaleString();
  } catch {
    return value;
  }
}
